import React, { useCallback } from 'react';
import { Text, Heading, Box, Flex, Switch } from '@televet/kibble-ui';
import AppointmentTypesTable from './AppointmentTypesTable';
import { useSurveySettingsContext, ISurveyGeneralSettings } from 'pages/Survey/context/SurveySettingsContext';
import { SurveyType } from 'shared/types/graphql';

interface AutomationSettingsProps {
  handleChange: (field: keyof ISurveyGeneralSettings, newValue: boolean) => void;
}

const AutomationSettings = ({ handleChange }: AutomationSettingsProps): JSX.Element => {
  const {
    generalSettings: { isAutomatedTriggerForAllAppointmentTypes },
    surveyType,
  } = useSurveySettingsContext();

  const handleEnableAllToggleChange = useCallback(() => {
    handleChange('isAutomatedTriggerForAllAppointmentTypes', !isAutomatedTriggerForAllAppointmentTypes);
  }, [handleChange, isAutomatedTriggerForAllAppointmentTypes]);

  return (
    <Box className="settings__container" mt="24px">
      <Heading className="settings__header" size="md" mb={2}>
        {surveyType} Survey Settings
      </Heading>
      <Text className="settings__description" variant="subtle">
        Control what appointments automatically trigger a{surveyType === SurveyType.Nps && 'n'} {surveyType} survey and
        set the delay time for how long post-appointment the survey should be sent.
      </Text>
      <Flex className="settings__fieldRow" flexDir="row" justify="space-between" mt="24px">
        <Text className="settings__fieldRow-label">
          Automatically send {surveyType} Survey for all appointment types
        </Text>
        <Flex className="settings__fieldRow-input" flexDir="row" align="baseline">
          <Switch
            onChange={handleEnableAllToggleChange}
            isChecked={isAutomatedTriggerForAllAppointmentTypes}
            pr="10px"
          />
          <Text size="xs">{isAutomatedTriggerForAllAppointmentTypes ? 'ON' : 'OFF'}</Text>
        </Flex>
      </Flex>
      <AppointmentTypesTable />
    </Box>
  );
};

export default AutomationSettings;
